/*
 * Primitive colors.
 * These reflect the colors in the Figma design system.
 * Do not modify these colors without design system approval.
 *
 * You should be using semantic colors instead of these in your components.
 */
export const colorPrimitive = {
  alpha: {
    transparent: 'rgba(0, 0, 0, 0)',
    black: {
      black50: 'rgba(0, 0, 0, 0.03)',
      black100: 'rgba(0, 0, 0, 0.05)',
      black200: 'rgba(0, 0, 0, 0.08)',
      black300: 'rgba(0, 0, 0, 0.12)',
      black400: 'rgba(0, 0, 0, 0.16)',
      black500: 'rgba(0, 0, 0, 0.2)',
      black1000: 'rgba(0, 0, 0, 0.4)',
      black1500: 'rgba(0, 0, 0, 0.6)',
      black2000: 'rgba(0, 0, 0, 0.80)',
    },
    white: {
      white50: 'rgba(255, 255, 255, 0.03)',
      white100: 'rgba(255, 255, 255, 0.05)',
      white200: 'rgba(255, 255, 255, 0.08)',
      white300: 'rgba(255, 255, 255, 0.12)',
      white400: 'rgba(255, 255, 255, 0.16)',
      white500: 'rgba(255, 255, 255, 0.2)',
      white1000: 'rgba(255, 255, 255, 0.4)',
      white1500: 'rgba(255, 255, 255, 0.6)',
      white2000: 'rgba(255, 255, 255, 0.8)',
    },
  },
  gray: {
    '50': '#fcfbfe',
    '100': '#f4f2f8',
    '200': '#eceaf1',
    '300': '#d8d6db',
    '400': '#a9abb2',
    '500': '#8d919b',
    '600': '#727683',
    '700': '#656972',
    '800': '#504c57',
    '900': '#352c3a',
    '950': '#221e29',
    '1000': '#15131b',
    '1050': '#110f15',
    white: '#ffffff',
    black: '#0b0910',
  },
  purple: {
    '50': '#fdfaff',
    '100': '#fbf5ff',
    '200': '#f4e8fd',
    '300': '#dacbf1',
    '400': '#cfb6ec',
    '500': '#b679f2',
    '600': '#a53eef',
    '700': '#9820ee',
    '800': '#7322a5',
    '900': '#492858',
    '1000': '#24172c',
  },
  blue: {
    '100': '#f5f8fe',
    '200': '#e6eefe',
    '300': '#c5d5fc',
    '400': '#79a7f6',
    '500': '#5d90ef',
    '600': '#2e70ea',
    '700': '#1665d5',
    '800': '#325385',
    '900': '#22244f',
    '1000': '#001b38',
  },
  teal: {
    '100': '#f0fdff',
    '200': '#cdf3f9',
    '300': '#99dfea',
    '400': '#22b6d3',
    '500': '#1f9fb2',
    '600': '#007f8f',
    '700': '#00758a',
    '800': '#005661',
    '900': '#003a42',
    '1000': '#001f24',
  },
  green: {
    '100': '#f3fcf8',
    '200': '#d7f4e7',
    '300': '#ade1c0',
    '400': '#5bb97d',
    '500': '#3ba554',
    '600': '#2d8643',
    '700': '#25793a',
    '800': '#245632',
    '900': '#153722',
    '1000': '#092011',
  },
  yellow: {
    '100': '#fefbf1',
    '200': '#f8eec3',
    '300': '#face47',
    '400': '#d5a401',
    '500': '#bd8728',
    '600': '#9d6c01',
    '700': '#906213',
    '800': '#65470b',
    '900': '#422e00',
    '1000': '#291600',
    highlight: '#fbf440',
  },
  orange: {
    '100': '#fff7f5',
    '200': '#ffe9e0',
    '300': '#ffcab2',
    '400': '#f6844c',
    '500': '#f36416',
    '600': '#d14900',
    '700': '#b84300',
    '800': '#8a3000',
    '900': '#572300',
    '1000': '#301303',
  },
  red: {
    '100': '#fef7f5',
    '200': '#ffe7e6',
    '300': '#fdcac3',
    '400': '#ff7c75',
    '500': '#fc4f4a',
    '600': '#eb150f',
    '700': '#d01501',
    '800': '#9e0f00',
    '900': '#660c05',
    '1000': '#3d0200',
  },
  magenta: {
    '100': '#fdf6fc',
    '200': '#fbeaf6',
    '300': '#f3c9e7',
    '400': '#edb0df',
    '500': '#f44ec2',
    '600': '#e231b6',
    '700': '#c01695',
    '800': '#8e1a71',
    '900': '#561a45',
    '1000': '#390528',
  },
  blurple: {
    '100': '#f5f6fe',
    '200': '#e6e9fe',
    '300': '#cad1fc',
    '400': '#94a2ff',
    '500': '#7989f7',
    '600': '#6257f4',
    '700': '#584def',
    '800': '#3c3faa',
    '900': '#20224b',
    '1000': '#101128',
  },
} as const;
